import clsx from "clsx";
import Image from "next/image";
import { Dispatch, SetStateAction } from "react";
import moveIcon from "@public/move.png";
import styles from "./MoveIcon.module.scss";

type Props = {
	disabled: boolean;
	setShowPartMove: Dispatch<SetStateAction<boolean>>;
	onShowChange: () => void;
};

/**
 * 移動アイコン コンポーネント
 * @returns {JSX.Element} 移動アイコン コンポーネント
 */
export default function MoveIcon(props: Props) {
	const { disabled, setShowPartMove, onShowChange } = props;

	return (
		<div className={styles.moveButton}>
			<Image
				src={moveIcon}
				alt="パーツ移動の表示非表示を切り替える"
				className={clsx(styles.icon, disabled && styles.disabled)}
				onClick={() => {
					if (!disabled) {
						setShowPartMove((prev) => !prev);
						onShowChange();
					}
				}}
			/>
		</div>
	);
}
